import {
	InfoMessageCommand,
	MCPrintMessageCommand,
	PrinterStatus,
	PrintMessageCommand,
	PushStatusResponse,
	VersionModule,
	AMSFilamentSettingResponse,
} from "./responses"
import * as mqtt from "mqtt"

export type StringNumber = `${number}`
export type StringBoolean = `${boolean}`

export type NumberRange<
	start extends number,
	end extends number,
	arr extends unknown[] = [],
	acc extends number = never,
> = arr["length"] extends end
	? acc | start | end
	: NumberRange<
			start,
			end,
			[...arr, 1],
			arr[start] extends undefined ? acc : acc | arr["length"]
		>

export type StringNumberRange<F extends number, T extends number> = `${NumberRange<F, T>}`


export interface IncomingMessageData {
	[key: string]: unknown
}

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>

export interface PrinterData extends Optional<PushStatusResponse, "command" | "sequence_id"> {
	modules: VersionModule[]
	model: PrinterModelNamesShort | undefined
}

export type ValueOf<T> = T[keyof T]

export type CommandResponse =
	| InfoMessageCommand
	| MCPrintMessageCommand
	| PrintMessageCommand
	| AMSFilamentSettingResponse

export type BambuClientPrinterStatus = PrinterStatus | "OFFLINE"

export type IConnackPacket = mqtt.IConnackPacket

export enum PrinterModelNamesShort {
	X1C = "X1C",
	X1 = "X1",
	X1E = "X1E",
	P1P = "P1P",
	P1S = "P1S",
	A1 = "A1",
	A1M = "A1M",
  }
